<div id="stats-menus-egalim" class="card mg-b-10 card-size" *ngIf="canDisplay()">
  <div class="card-header">
    <div class="d-flex">
      <div class="flex-grow-1">
        <span class="mg-r-5">Analyse Egalim pour la prestation</span>
        <strong>{{ mp2Svc?.planningMenus?.contratMenuConviveList[0]?.contratMenuLibelle }}
          - {{ mp2Svc?.planningMenus?.contratMenuConviveList[0]?.libelle }} (Unité de production {{ udp }}) </strong>
      </div>

      <div class="mg-r-5">
        <yo-commande-fournisseur-date-filter
          (onValueChange)="onDateFilterValueChange($event)"
          height="45px"
          [selectedDates]="selectedPeriode"
        >
        </yo-commande-fournisseur-date-filter>
      </div>
    </div>
  </div>
  <div class="card-body">
    <ng-container *ngIf="!dataGraphic">
      <p>Veuillez sélectionner une période et saisir un effectif</p>
    </ng-container>
    <ng-container *ngIf="dataGraphic">
      <yo-indicateur-egalim
        [values]="[dataGraphic.pourcentageDurable, dataGraphic.pourcentageBio, dataGraphic.pourcentageMontantProduitsPoissonViande]"
        [inputSeuils]="seuils"
        [isConformeEgalim]="dataGraphic.egalim"
        [subtitle]="getPeriod() + '<br>' +udp"
        [titleText]="customizeTextLabel"
        [tooltipText]="customizeTooltip"
        [legendText]="customizeText"
        (onChangeSeuil)="changeSeuil($event)">
      </yo-indicateur-egalim>
    </ng-container>
  </div>

</div>
